module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham-1f831dc4cdd95c43355c02ffd9081679.svg";